export default "__VITE_ASSET__M_8zMY85__"